import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function usePostAdminImportRequestDone() {
  const queryClient = useQueryClient();
  const token = (document.getElementsByName('csrf-token')[0] as HTMLMetaElement | undefined)
    ?.content;

  return useMutation({
    mutationFn: async (importRequestId: number) => {
      const response = await fetch(`/admin/api/import_requests/${importRequestId}/done`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-CSRF-Token': token || '',
        },
      });
      if (!response.ok) {
        const body = await response.json().catch(() => ({}));
        throw new Error((body as { error?: string }).error ?? 'リクエスト完了の記録に失敗しました');
      }
      return response.json();
    },
    onSuccess: (_data, importRequestId) => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'import_requests', importRequestId] });
      queryClient.invalidateQueries({ queryKey: ['admin', 'import_requests'] });
      queryClient.invalidateQueries({
        queryKey: ['admin', 'import_requests', importRequestId, 'items'],
      });
    },
  });
}
